import request from "@/utils/request";
export default {
    /**
     * 保存客户信息
     * @returns
     */
    customerSave:(data) => request.post('/webservice/customer/save', data),
}